"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _form = require("@sharingapples/form");

var _utils = require("@dom/utils");

function TextInput(props, ref) {
  var label = props.label,
      _props$inputType = props.inputType,
      inputType = _props$inputType === void 0 ? 'text' : _props$inputType,
      name = props.name,
      error = props.error,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      small = props.small,
      rest = (0, _objectWithoutProperties2["default"])(props, ["label", "inputType", "name", "error", "className", "small"]);

  var _useFormInput = (0, _form.useFormInput)(name),
      _useFormInput2 = (0, _slicedToArray2["default"])(_useFormInput, 2),
      value = _useFormInput2[0],
      onChange = _useFormInput2[1];

  var handleChange = _react["default"].useCallback(function (e) {
    return onChange(e.target.value);
  }, [onChange]);

  return _react["default"].createElement("div", {
    className: className
  }, label && _react["default"].createElement("label", {
    htmlFor: name
  }, label, " ", _react["default"].createElement("small", null, small)), _react["default"].createElement("input", (0, _extends2["default"])({
    id: name,
    type: inputType,
    ref: ref,
    value: value,
    onChange: handleChange,
    className: "form-control ".concat((0, _utils.getErrorClassName)(error)),
    "aria-label": label || props['aria-label']
  }, rest)));
}

var _default = _react["default"].forwardRef(TextInput);

exports["default"] = _default;